import { buildPromptIntelligence, type PromptIntelligenceResult, type PromptSettingsPreset } from '@/ai/grokPromptService';

type SceneDetection = {
  subject: string;
  environment: string;
  lighting: string;
  mood: string;
};

const localDetectScene = (prompt: string): SceneDetection => {
  const text = prompt.trim();
  const lower = text.toLowerCase();
  const dark = /dark|night|مظلم|ليل/.test(lower);

  return {
    subject: /warrior|محارب|samurai|ساموراي/.test(lower) ? 'warrior' : text.split(/[,.]/)[0]?.trim() || 'main subject',
    environment: /temple|معبد/.test(lower) ? 'temple' : /forest|غابة/.test(lower) ? 'forest' : 'cinematic environment',
    lighting: dark ? 'dark torch light' : 'soft cinematic light',
    mood: /dramatic|درامي|epic/.test(lower) ? 'dramatic' : 'cinematic',
  };
};

export const intelligence = {
  detectScene(prompt: string): SceneDetection {
    return localDetectScene(prompt);
  },

  async analyzePrompt(prompt: string): Promise<PromptIntelligenceResult> {
    return buildPromptIntelligence(prompt);
  },

  autoDirector(prompt: string): PromptSettingsPreset {
    const scene = localDetectScene(prompt);
    const dramatic = /dramatic|dark/.test(`${scene.mood} ${scene.lighting}`);

    return {
      camera: dramatic ? 'low angle shot' : 'eye-level medium shot',
      lighting: dramatic ? 'low key cinematic lighting' : 'soft cinematic daylight',
      style: 'cinematic photorealistic',
      composition: dramatic ? 'centered cinematic with negative space' : 'rule of thirds',
      mood: scene.mood,
      lens: dramatic ? '85mm lens' : '50mm lens',
      palette: dramatic ? 'cinematic-blue-hour-soft' : 'cinematic-golden-sunset-soft',
      renderQuality: '4k',
    };
  },
};
